export const android = {
  id: 'android',
  label: 'Android',
  emoji: '🤖',
  colorScheme: 'green',
  description: 'Google Play & launcher icons',
  folder: 'android',
  icons: [
    { filename: 'ic_launcher.png', size: 36,  density: 'ldpi',     folder: 'android/mipmap-ldpi',     label: 'ldpi (0.75x)' },
    { filename: 'ic_launcher.png', size: 48,  density: 'mdpi',     folder: 'android/mipmap-mdpi',     label: 'mdpi (1x)' },
    { filename: 'ic_launcher.png', size: 72,  density: 'hdpi',     folder: 'android/mipmap-hdpi',     label: 'hdpi (1.5x)' },
    { filename: 'ic_launcher.png', size: 96,  density: 'xhdpi',    folder: 'android/mipmap-xhdpi',    label: 'xhdpi (2x)' },
    { filename: 'ic_launcher.png', size: 144, density: 'xxhdpi',   folder: 'android/mipmap-xxhdpi',   label: 'xxhdpi (3x)' },
    { filename: 'ic_launcher.png', size: 192, density: 'xxxhdpi',  folder: 'android/mipmap-xxxhdpi',  label: 'xxxhdpi (4x)' },
    { filename: 'ic_launcher_round.png', size: 36,  density: 'ldpi',    folder: 'android/mipmap-ldpi',    label: 'Round ldpi' },
    { filename: 'ic_launcher_round.png', size: 48,  density: 'mdpi',    folder: 'android/mipmap-mdpi',    label: 'Round mdpi' },
    { filename: 'ic_launcher_round.png', size: 72,  density: 'hdpi',    folder: 'android/mipmap-hdpi',    label: 'Round hdpi' },
    { filename: 'ic_launcher_round.png', size: 96,  density: 'xhdpi',   folder: 'android/mipmap-xhdpi',   label: 'Round xhdpi' },
    { filename: 'ic_launcher_round.png', size: 144, density: 'xxhdpi',  folder: 'android/mipmap-xxhdpi',  label: 'Round xxhdpi' },
    { filename: 'ic_launcher_round.png', size: 192, density: 'xxxhdpi', folder: 'android/mipmap-xxxhdpi', label: 'Round xxxhdpi' },
    { filename: 'ic_launcher-playstore.png', size: 512, density: 'store', folder: 'android', label: 'Play Store (512×512)' },
  ],
};
